module.exports = __webpack_public_path__ + "static/media/money_bonus_2.30822146.webp";